import React from 'react';
import { useIntl } from 'react-intl';
import { useAtomValue } from 'jotai';
import PropTypes from 'prop-types';
import CancelIcon from '@mui/icons-material/Cancel';
import {
  FormControl,
  ListItemText,
  Typography,
  Select,
  MenuItem,
  Checkbox,
  Chip,
  Box,
} from '@mui/material';
import { occupationsAtom } from '../../Atoms';
import capitalize from '../../Helpers/StringsFormatting/capitalize';

//REMEMBER TO USE MultipleChipSelect INSTEAD OF THIS COMPONENT (in dev)
const OccupationSelect = function OccupationSelect({ values, onChange }) {
  const intl = useIntl();
  const occupations = useAtomValue(occupationsAtom);

  const handleRemoveBranch = (e, value) => {
    e.preventDefault();
    const copyItems = [...values]; //copy of branches
    const index = copyItems.indexOf(value);
    if (index !== -1) {
      copyItems.splice(index, 1);
      if (onChange) onChange(copyItems);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%"
      }}>
      <Typography sx={{ fontSize: '14px' }}>
        {intl.messages.OCCUPATION}:
      </Typography>
      <FormControl fullWidth>
        <Select
          id="occupations"
          value={values}
          multiple
          onChange={(e) => {
            if (onChange) {
              onChange(e.target.value);
            }
          }}
          renderValue={(selected) => (
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 0.5,
                maxHeight: '56px',
                overflowY: 'auto',
              }}
            >
              {selected?.map((value) => (
                <Chip
                  clickable
                  key={value}
                  label={capitalize(value)}
                  deleteIcon={
                    <CancelIcon
                      onMouseDown={(event) => event.stopPropagation()}
                    />
                  }
                  onDelete={(e) => handleRemoveBranch(e, value)}
                />
              ))}
            </Box>
          )}
        >
          {occupations?.map((x) => (
            <MenuItem key={x} value={x}>
              <Checkbox
                checked={Boolean((values || [])?.find((item) => item === x))}
              />
              <ListItemText primary={x || intl.messages.NO_SELECTION} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

OccupationSelect.propTypes = {
  values: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};
export default OccupationSelect;
